"use client"

import { Localized } from "@/i18n/client"
import { useEffect, useRef, useState } from "react"
import { Pause, Play } from "lucide-react"
import { useReducedMotion } from "@/hooks/use-reduced-motion"
import styles from "./pages.module.css"

export function EditorialVideo({ src, poster, label }: { src: string; poster: string; label: string }) {
  const ref = useRef<HTMLVideoElement>(null)
  const reducedMotion = useReducedMotion()
  const [enabled, setEnabled] = useState(false)
  const [playing, setPlaying] = useState(false)
  const [failed, setFailed] = useState(false)
  useEffect(() => {
    const video = ref.current
    if (!video || reducedMotion || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setEnabled(true)
      else video.pause()
    }, { threshold: 0.15 })
    observer.observe(video)
    return () => observer.disconnect()
  }, [reducedMotion])
  useEffect(() => {
    if (enabled && !reducedMotion) ref.current?.play().catch(() => setPlaying(false))
    if (reducedMotion) ref.current?.pause()
  }, [enabled, reducedMotion])
  async function toggle() {
    const video = ref.current
    if (!video) return
    if (playing) video.pause()
    else {
      if (!enabled) setEnabled(true)
      try { await video.play() } catch { setFailed(true) }
    }
  }
  return <Localized>{<><video ref={ref} className={styles.heroVideo} src={src} poster={poster} muted loop playsInline preload="none" aria-label={label} onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onError={() => { setPlaying(false); setFailed(true) }} />{!failed ? <button type="button" onClick={toggle} className={styles.videoControl} aria-label={playing ? "Pause background video" : "Play background video"}>{playing ? <Pause size={19} /> : <Play size={19} />}</button> : null}</>}</Localized>
}
